import { DeheadingReportingTypeEnum, OperationTypeEnum, ShiftsEnum } from "@gtpl/shared-models/common-models";

export class OperationReportingReq{
    operation : OperationTypeEnum;
    prevOperation : OperationTypeEnum
    batchNumber : string
    reportedQty : number
    shift : ShiftsEnum
    workStation: number
    count: number
    reportingType : DeheadingReportingTypeEnum
    product : string
    plantId : number
    createdUser: string
    grade?:number
     
    constructor(operation : OperationTypeEnum,prevOperation : OperationTypeEnum,batchNumber : string,reportedQty : number,shift : ShiftsEnum,workStation: number,count: number,reportingType : DeheadingReportingTypeEnum,product : string,plantId : number,createdUser: string,grade?:number){
    this.operation = operation 
    this.prevOperation = prevOperation 
    this.batchNumber = batchNumber 
    this.reportedQty = reportedQty 
    this.shift = shift 
    this.workStation= workStation
    this.count= count
    this.reportingType = reportingType 
    this.product = product 
    this.plantId = plantId
    this.createdUser = createdUser
    this.grade = grade
    }
}